import {
  EntityFormFieldName,
  addOppExpectedClosingDate,
  addOppName,
  addOppOwnerId,
  addOppStageId,
  addOppUseSystemName,
  entityCampaignId,
  entityLeadSourceId,
  entityNextActionDate,
  entityPreferredMethodOfContact,
  entityPreferredTimeOfContact,
  entityReferral,
  entitySalesFunnelId,
  entitySalesTeamId,
  entityTargetPests,
  addLeadNote,
} from '../constants'
import { combineTopCards, customOrder } from './registryData'
import { findRequiredGroup } from './requiredGroups'
import { FieldConfig } from './typings'

/**
 * The fields that make up the Opportunity field-settings screen, in the order the
 * server seeds them.
 *
 * `order` and `combineWithNext` are computed below from the registry source
 * data at module init rather than hand-transcribed, so they cannot drift out
 * of sync with it.
 *
 * Section grouping is deliberately absent: a field's section is server-owned
 * per-record data (`IEntityFormSetting.sectionId`) and stays driven by each
 * record's own value at render time.
 */
const opportunityFieldIds: EntityFormFieldName[] = [
  addOppUseSystemName,
  addOppName,
  entitySalesTeamId,
  addOppOwnerId,
  entitySalesFunnelId,
  addOppStageId,
  addOppExpectedClosingDate,
  entityPreferredMethodOfContact,
  entityPreferredTimeOfContact,
  entityNextActionDate,
  addLeadNote,
  entityCampaignId,
  entityLeadSourceId,
  entityReferral,
  entityTargetPests,
]

export const opportunityFieldConfig: FieldConfig[] = opportunityFieldIds.map(
  (id) => {
    const config: FieldConfig = {
      id,
      order: customOrder.indexOf(id),
      combineWithNext: combineTopCards.includes(id),
      requiredGroup: findRequiredGroup(id),
    }
    if (id === addOppStageId) {
      config.renderer = 'opportunityStage'
    }
    return config
  },
)
